<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>地址管理</span></div>
			<div class="center flex-between">
				<centerLeft :menu="4"></centerLeft>
				<div class="center-right">
					<div class="address-top flex-between flex-center">
						<div class="address-top-left">收货地址<span>(地址最多 <span>10</span> 条，还能保存 <span>{{10-list.length}}</span> 条)</span></div>
						
						<div class="address-top-right flex-end flex-center" v-if="list.length < 10" @click="add">
							<img src="@/assets/images/add.png"/>
							新建地址
						</div>
					</div>
					
					<div class="address-list" v-if="list.length > 0">
						<div v-for="item in list" class="address flex-between flex-center">
							<div class="address-info" >
								<div><span>收货人：</span>{{item.receiveName}}</div>
								<div><span>联系方式：</span>{{item.phone}}</div>
								<div><span>收货地址：</span>{{item.province}}{{item.city}}{{item.county}}{{item.detailAddress}}</div>
							</div>
							<div class="address-action">
								<div class="address-action-icon" v-if="item.defaultStatus == 0">默认地址</div>
								<div class="address-action-setting" v-else @click="setDefault(item.id)">设为默认</div>
								
								<div class="address-action-text">
									<span @click="editAddress(item.id)">编辑</span>
									<span @click="deleteAddress(item.id)">删除</span>
								</div>
							</div>
						</div>
					</div>
					
					<noData v-if="list.length == 0 && isLoad == true" msg="暂无地址"></noData>
				</div>
			</div>
		</div>
	  </div>
	  
	  <addressForm ref="addressRef" @success="getList"></addressForm>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import noData from '@/components/noData.vue'
import addressForm from '@/components/addressForm.vue'
import {getAddressList,setDefaultStatus,deleteAddress} from "@/api/user"
export default {
	name: 'index',
	components:{
		centerLeft,
		noData,
		addressForm
	},
	data(){
		return {
			list:[],
			isLoad:false
		}
	},
	mounted() {
		this.isLoad = false;
		this.getList();
	},
	methods:{
		getList(){
			getAddressList({condition:{},page:1,size:100}).then(res=>{
				if(res.code == 1000){
					this.list = res.data.list;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		//打开添加地址的弹框
		add(){
			this.$refs.addressRef.init(0);
		},
		//编辑地址
		editAddress(id){
			this.$refs.addressRef.init(id);
		},
		setDefault(id){
			setDefaultStatus({id:id}).then(res=>{
				if(res.code == 1000){
					this.getList();
					this.$message.success("设置成功");
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		deleteAddress(id){
			this.$alert('确定要删除地址吗？', '提示', {
				confirmButtonText: '确定',
				showCancelButton:true,
				callback: action => {
					if(action  == "confirm"){
						deleteAddress({id:id}).then(res=>{
							if(res.code == 1000){
								this.getList();
								this.$message.success("删除成功");
							}else{
								return this.$message.error(res.message);
							}
						})
					}
				}
			});
		}
	}
}
</script>

<style lang="scss" scoped>
	.address-list{
		.address{
			border: 1px solid rgba(0, 0, 0, 0.1);
			box-sizing: border-box;
			padding: 20px 0px 20px 30px;
			margin-bottom: 20px;
			.address-info{
				width: 100%;
				border-right: 1px solid rgba(7, 11, 19, 0.1);
				div{
					font-size: 16px;
					line-height: 22px;
					color: #070B13;
					padding: 8px 0px;
					span{
						width: 90px;
						font-size: 16px;
						color: rgba(7, 11, 19, 0.6);
						display: inline-block;
					}
				}
			}
			.address-action{
				width: 184px;
				text-align: center;
				.address-action-icon{
					width: 104px;
					height: 28px;
					background: #E91A12;
					font-size: 14px;
					line-height: 28px;
					color: #FFFFFF;
					text-align: center;
					margin: 0 auto;
				}
				.address-action-setting{
					width: 104px;
					height: 28px;
					border: 1px solid rgba(7, 11, 19, 0.3);
					font-size: 14px;
					line-height: 28px;
					color: rgba(7, 11, 19, 1);
					text-align: center;
					margin: 0 auto;
					cursor: pointer;
				}
				.address-action-text{
					margin-top: 20px;
					text-align: center;
					span{
						font-size: 14px;
						color: #165DFF;
						margin: 0px 10px;
						cursor: pointer;
						&:last-of-type{
							color: #E91A12;
						}
					}
				}
			}
		}
	}
	.address-top{
		.address-top-left{
			height: 64px;
			line-height: 64px;
			font-size: 16px;
			font-weight: 500;
			color: #070B13;
			span{
				font-size: 14px;
				span{
					color: #E91A12;
				}
			}
		}
		.address-top-right{
			font-size: 14px;
			line-height: 20px;
			color: #070B13;
			cursor: pointer;
			img{
				width: 20px;
				height: 20px;
				margin-right: 5px;
			}
		}
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding: 0px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	@import url("../assets/user.scss");
</style>
